import React from 'react'
import Base from './Base'
import Success from '../../Images/success.gif'
import Error from '../../Images/error.gif'
import Warning from '../../Images/warning.gif'
import StepsUserFormBase from './StepsUserFormBase'
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import { Form, Card , Button, Row, Col, message } from "antd"
import { withBreakpoints } from "react-breakpoints"
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class PostCheckoutError extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            msg : ""
        }
    }

    componentDidMount(){
        try {
            const errObj = JSON.parse(this.props.history.location.state.errorMessage.message)
            const defaultMessage = "Ocurrio un error al procesar tu pago, por favor contactate con un administrador"
            errObj.statusCode === 500 ? this.setState({msg: defaultMessage}) : this.setState({msg: this.props.history.location.state.errorMessage})
        }catch(err){
            console.log(err)
            this.setState({msg: this.props.history.location.state.errorMessage})
        }
    }

    render() {
        if (this.props.history.location.state.isStepUser){
            return(
                <StepsUserFormBase>
                    <center>
                        <h1> {this.state.msg}</h1>
                        <h1> Vas a ser redireccionado para comenzar nuevamente</h1>
                        <img alt="error" src={Error} className="error-checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />
                    </center>
                    <center>
                        <Col>
                            <Row>
                                <Button 
                                    style={{
                                    color: '#FFFFFF' ,
                                    background: '#353FDF',
                                    border: '1px solid #353FDF',
                                    borderRadius: '5px',
                                    marginBottom: '10px', 
                                    }}
                                    onClick={() => this.props.history.push("/initial-plan/0")}> Volver 
                                </Button>
                            </Row>
                            <Row>
                                <Button 
                                    onClick={() => this.props.history.push("/")}> Continuar sin pagar 
                                </Button>
                            </Row>
                        </Col>
                    </center>
                </StepsUserFormBase>
            )
        }else{
            return(
                <Base
                    selected = "checkout-error">
                    <Card>
                        <center>
                                <h1> {this.state.msg} </h1>
                                <h1> Vas a ser redireccionado para comenzar nuevamente</h1>
                            <img alt="error" src={Error} className="error-checkout" style={{ height: "300px", marginTop: "15px", marginBottom: "15px" }} />
                        </center>
                        <center>
                        <Button 
                            style={{
                                color: '#FFFFFF' ,
                                background: '#353FDF',
                                border: '1px solid #353FDF',
                                borderRadius: '5px' 
                            }}
                            onClick={() => this.props.history.push("/mejorar-plan")}> Reintentar 
                        </Button>
                        </center>
                    </Card>
                </Base>
            )
        }
    }


}

const Checkout = Form.create({ nombre: 'checkout-error' })(withBreakpoints(PostCheckoutError));
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Checkout));